import {Typed} from "app/stimulus/typed-stimulus";
import {Controller} from "@hotwired/stimulus";
import Select from "app/components/select";

/**
 * Proxy Stimulus controller to old style Select component
 */
export default class extends Typed(Controller<HTMLElement>)
{
    private select: Select | null = null;

    public connect(): void {
        this.select = Select.getOne(this.element);
    }

    public disconnect(): void {
        this.select?.destroy();
        Select.clearInstance(this.element);
    }
}
